import * as atlas from 'azure-maps-control';
import { useTheme } from '@mui/material';
import { useState, useEffect } from 'react';
import { useAzureMap } from '@chr/online-shared-ui-maps';
import { useTrackingMap } from './TrackingMapProvider';
import { useGetDisruptions } from '@/common/apis/disruptions-query';
import { addDisruptionsToDataSource, getDisruptionsLayers } from './mapHelpers';
import { Map } from 'azure-maps-control';
import { GetDisruptionsRequest } from '@/common/constants/map-display-types';

export const TrackingMapDisruptionsLayer = () => {
  const { isMapReady, mapStyle } = useAzureMap();
  const { isDisruptionsEnabled, map } = useTrackingMap();

  const { palette } = useTheme();

  const [popup] = useState<atlas.Popup>(new atlas.Popup({ pixelOffset: [0, -2] }));

  const layers = getDisruptionsLayers(map as Map, isMapReady, palette, popup);

  const disruptionsRequest = { showExpired: false } as GetDisruptionsRequest;

  const disruptionsResult = useGetDisruptions(disruptionsRequest);
  const disruptions = disruptionsResult.data?.disruptions ?? [];

  useEffect(() => {
    if (layers) {
      layers.borders.setOptions({ visible: isDisruptionsEnabled });
      layers.areas.setOptions({ visible: isDisruptionsEnabled });
      if (!isDisruptionsEnabled) {
        popup.close();
      }
    }
  }, [layers, isDisruptionsEnabled, popup]);

  useEffect(() => {
    layers?.borders.setOptions({ strokeColor: palette.map.disruptions.primary });
  }, [layers, palette, mapStyle]);

  useEffect(() => {
    addDisruptionsToDataSource(isMapReady, map as Map, disruptions);
  }, [isMapReady, map, disruptions]);

  return null;
};
